function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useContext } from 'react';
import { TableBody, Skeleton, TableRow } from '@mui/material';
import TCell from "./TCell";
import TableContext from "./context";
import RowContent from "./RowContent";
import TEmpty from "./TEmpty";
var TBody = function TBody() {
  var _useContext = useContext(TableContext),
    loading = _useContext.loading,
    dataSource = _useContext.dataSource,
    columns = _useContext.columns,
    size = _useContext.size,
    rowKey = _useContext.rowKey;
  return /*#__PURE__*/React.createElement(TableBody, null, loading && _toConsumableArray(new Array(Math.min(dataSource.length || 0, 40) || 10).keys()).map(function (item) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: "".concat(item, "_skeleton")
    }, columns.map(function (column) {
      return /*#__PURE__*/React.createElement(TCell, {
        key: column.dataIndex,
        size: size,
        sx: {
          width: column.width,
          minWidth: column.minWidth
        }
      }, /*#__PURE__*/React.createElement(Skeleton, {
        key: column.dataIndex,
        variant: "text"
      }));
    }));
  }), !loading && dataSource.map(function (data, index) {
    var _data;
    var key = (_data = data[rowKey]) !== null && _data !== void 0 ? _data : index;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: key
    }, /*#__PURE__*/React.createElement(RowContent, {
      index: index,
      row: data
    }));
  }), /*#__PURE__*/React.createElement(TEmpty, null));
};
export default TBody;